export default defineNuxtRouteMiddleware(() => {
  if (IS_MOBILE) {
    return navigateTo('/dashboard/empty', { replace: true })
  }
})
